import cx from 'classnames'
import React, { HTMLAttributes } from 'react'

import { ArrowRightIcon } from '@/components/Icons/ArrowRightIcon'
import ULink from '@/components/Link/ULink'
import '@/components/LinkButtonArrow/LinkButtonArrow.scss'

type Props = {
  href: string
  target?: string
  className?: string
  reverse?: boolean
  triangle?: boolean
  nextLink?: boolean
} & HTMLAttributes<HTMLAnchorElement>
const LinkButtonArrow = ({
  children,
  href,
  target = '_self',
  className,
  reverse = false,
  triangle = false,
  nextLink = true,
}: Props) => {
  return (
    <ULink
      nextLink={nextLink}
      href={href}
      target={target}
      className={cx(
        `c-linkButtonArrow u-mo-crop u-mo-arrow`,
        {
          'c-linkButtonArrow--reverse': reverse,
        },
        className
      )}
    >
      <div className="u-mo-crop__container">
        <span className="u-mo-crop__text u-mo-crop__text--inner">{children}</span>
        <span className="u-mo-crop__text u-mo-crop__text--outer">{children}</span>
      </div>

      <div className="u-mo-crop__icon u-mo-arrow--inner">
        {triangle ? (
          <div
            style={{
              width: '0.75em',
              height: '0.5em',
              marginRight: '0.6666666667em',
              backgroundColor: 'currentColor',
              clipPath: 'polygon(0 0, 0% 100%, 100% 50%)',
              transition: 'background-color 200ms',
            }}
          ></div>
        ) : (
          <ArrowRightIcon />
        )}
      </div>
    </ULink>
  )
}

export default LinkButtonArrow
